// extracted by mini-css-extract-plugin
export default {"mark":"BrandMark_mark__fsSKd"};